import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { ProductsProvider } from './context/ProductsContext';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from './components/ui/toaster';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Terms from './pages/Terms';
import Account from './pages/Account';
import Favorites from './pages/Favorites';
import Contact from './pages/Contact';
import Admin from './pages/Admin';

const ShopLayout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
    <CartDrawer />
    <WhatsAppButton />
  </>
);

function App() {
  return (
    <div className="App">
      <CartProvider>
        <ProductsProvider>
          <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Admin runs standalone, without Header/Footer/Cart/WhatsApp */}
            <Route path="/admin" element={<Admin />} />

            <Route element={<ShopLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/magazin" element={<Shop />} />
              <Route path="/categorie/:slug" element={<Shop />} />
              <Route path="/produs/:slug" element={<ProductDetail />} />
              <Route path="/cos" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/termeni-si-conditii" element={<Terms />} />
              <Route path="/cont" element={<Account />} />
              <Route path="/favorite" element={<Favorites />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/livrare" element={<Terms />} />
              <Route path="/retur" element={<Terms />} />
              <Route path="/confidentialitate" element={<Terms />} />
              <Route path="/comparatie" element={<Favorites />} />
            </Route>
          </Routes>
          <Toaster />
        </BrowserRouter>
        </ProductsProvider>
      </CartProvider>
    </div>
  );
}

export default App;
